import { Component } from '@angular/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent {
  hubs = [
    {
      city: 'Funza, Cundinamarca',
      tag: 'Principal',
      area: '6.000 m² almacenamiento automatizado',
      coverage: 'Servicio centro del país, Bogotá y Cundinamarca',
      capacity: '12.000 envíos/día'
    },
    {
      city: 'Sabaneta, Antioquia',
      tag: 'Noroccidente',
      area: '3.200 m² dedicados al Eje Cafetero y Antioquia',
      coverage: 'Medellín y área metropolitana express same-day',
      capacity: '6.000 envíos/día'
    },
    {
      city: 'Yumbo, Valle del Cauca',
      tag: 'Pacífico',
      area: '2.800 m² conectando Cali, Buenaventura y Nariño',
      coverage: 'Despachos continuos a la región suroccidente',
      capacity: '5.000 envíos/día'
    },
    {
      city: 'Galapa, Atlántico',
      tag: 'Costa Caribe',
      area: '2.500 m² para atención en la Costa Norte',
      coverage: 'Barranquilla, Cartagena, Santa Marta y Valledupar',
      capacity: '4.500 envíos/día'
    }
  ];
}
